
































































































































import { Component, Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../../config/objectFactory';
import { MedTransGoConstants } from '../../util/constants';
import { ApiRequest, QueryRecordsRequest, Document } from '../../types/request';
import { Patient, ServiceRequest } from '../../types/entity';
import DataTable from '../../components/DataTable.vue';
import { CommonUtils } from '../../util/commonUtils';
import '../../assets/css/ViewPatientModal.scss';
import { DateUtils } from '../../util/dateUtils';
import { ResourceUtils } from '../../util/resourceUtils';
import { ToastEvent } from '@/types/event';
import { EventBus } from '@/main';
import UploadPatientLienDocumentModal from './UploadPatientLienDocumentModal.vue';
import ViewLienDocumentModal from './ViewLienDocumentModal.vue';
import { MemberProfile } from '@/types/response';

declare var Buffer: any;
// tslint:disable-next-line: no-var-requires
const TransportationTable = require('../../datatable/PatientTransportRequestsTable.json');
// tslint:disable-next-line: no-var-requires
const InterpretationTable = require('../../datatable/PatientInterpreterRequestsTable.json');
// tslint:disable-next-line: no-var-requires
const TelemedicineTable = require('../../datatable/PatientTelemedicineRequestsTable.json');
// tslint:disable-next-line:no-var-requires
const DeliveryTable = require('../../datatable/PatientDeliveryRequestsTable.json');
// tslint:disable-next-line:no-var-requires
const LienRequestDocumentTable = require('../../datatable/LienRequestDocumentTable.json');
@Component({
    data() {
        return {
            imagePreview: '',
        };
    },
    components: {
        DataTable,
        UploadPatientLienDocumentModal,
        ViewLienDocumentModal,
    },
    methods: {
        formatDate(date: any) {
            return DateUtils.formatDate(date, DateUtils.FORMAT_DATETIME_AM_PM);
        },
    },
})
export default class ViewPatientModal extends Vue {
    private patient: Patient | undefined;
    private id: string = '';
    private show = false;
    private transportationTableDataSource = TransportationTable;
    private interpretationTableDataSource = InterpretationTable;
    private telemedicineDataSource = TelemedicineTable;
    private deliveryTableDataSource = DeliveryTable;
    private lienDocumentDataSource = LienRequestDocumentTable;
    private showUploadDocumentModal = false;
    private selectedDocument: Document | null = null;
    private memberProfile: MemberProfile = ObjectFactory.getCacheService().getMemberInfo();
    private outputProperties = [
        'telemedicineRequest',
        'transportRequest',
        'interpreterRequest',
        'deliveryRequest',
        'appointment',
        'createdOn',
        'status',
    ];

    private mounted() {
        this.id = this.$route.params.id;
        this.getPatientDetails(this.$route.params.id);
        this.getPatientRequests();
    }

    /**
     * @author <Durga.S>
     * @description - Returns patient's details by patient Id
     * @param req {Request} - Express Request - patient Id
     * @param res {Response} - Express Response - patient details
     * @returns patient details
     * @throws InvalidRequestException if patient id is invalid
     */
    private async getPatientDetails(patientId: string) {
        this.lienDocumentDataSource.data = [];
        const response = await ObjectFactory.getPatientService().getPatientDetails(this.$store.state.serverUrl,
        patientId);
        if (response.success && response.data) {
            this.patient = response.data;
            if (response.data.profilePhoto) {
                this.getPatientProfileImage(response.data.profilePhoto);
            } else {
                this.$data.imagePreview = require('../../assets/images/NoProfile.jpg');
            }
            this.show = true;
            if (response.data.documents) {
                this.lienDocumentDataSource.data = response.data.documents;
                await this.getPatientLienRequestDocuments();
            } else {
                this.lienDocumentDataSource.data = [];
            }
        } else {
            CommonUtils.showError(response);
        }
    }

    private async getPatientProfileImage(resourceId: string) {
        this.$data.imagePreview = require('../../assets/images/loader_download.gif');
        this.$data.imagePreview = await ResourceUtils.getResourceUrl(this.$store.state.serverUrl, resourceId);
    }


    /**
     * @author <Aniket.P>
     * @description - gets service requests
     * @param req {Request} - Express Request - request type - patient Id
     * @param res {Response} - Express Response - service requests
     * @returns service requests
     * @throws InvalidRequestException if request type and patient Id is invalid
     */
    private async getServiceRequests(requestType: string, patientId: string): Promise<ServiceRequest[]> {
        const queryRecordsRequest: QueryRecordsRequest = {
        conditions: [
            {
                op: 'ne',
                fieldName: requestType,
                value: null,
            },
            {
                op: 'eq',
                fieldName: 'appointment.patient.id',
                value: patientId,
            },
        ],
        order: {
            appointmentTimestamp: -1,
        },
        outputProperties: this.outputProperties,
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_REQUEST}/list`,
            data: queryRecordsRequest,
            loaderEvent: {
                show: true,
            },
        };
        const iHttpService = ObjectFactory.getHttpService();
        const response = await iHttpService.post<ServiceRequest[]>(apiRequest);
        return response.data ? response.data : [];
    }

    /**
     * @author <Durga.S>
     * @description - gets service requests for transportation and interpretation of a patient
     * @param req {Request} - Express Request -
     * @param res {Response} - Express Response - service requests
     * @returns service requests
     * @throws InvalidRequestException
     */
    private async getPatientRequests() {
        const interpretationResponse = await this.getServiceRequests('interpreterRequest', this.$route.params.id);
        if (interpretationResponse) {
            interpretationResponse.forEach((element: any) => {
                const hours = element.interpreterRequest.estimatedTime.hours;
                const minutes = element.interpreterRequest.estimatedTime.minutes;
                element.interpreterRequest.estimatedTime = `${hours}:${minutes} Hrs`;
                element.appointment.date = DateUtils.formatDate
                (element.appointment.timestamp, DateUtils.FORMAT_DATETIME_AM_PM, element.appointment.timezone);
                element.createdOn = DateUtils.formatDate(element.createdOn, DateUtils.FORMAT_DATETIME_AM_PM);
            });
        }
        this.interpretationTableDataSource.data = interpretationResponse;
        const transportationResponse = await this.getServiceRequests('transportRequest', this.$route.params.id);
        if (transportationResponse) {
            transportationResponse.forEach((element: any) => {
                element.appointment.date =
                    DateUtils.formatDate(element.appointment.timestamp, DateUtils.FORMAT_DATETIME_AM_PM,
                    element.appointment.timezone);
                element.createdOn = DateUtils.formatDate(element.createdOn, DateUtils.FORMAT_DATETIME_AM_PM);
            });
        }
        this.transportationTableDataSource.data = transportationResponse;
        const telemedicineResponse = await this.getServiceRequests('telemedicineRequest', this.$route.params.id);
        if (telemedicineResponse) {
            telemedicineResponse.forEach((element: any) => {
                element.appointment.date =
                    DateUtils.formatDate(element.appointment.timestamp, DateUtils.FORMAT_DATETIME_AM_PM,
                    element.appointment.timezone);
                element.createdOn = DateUtils.formatDate(element.createdOn, DateUtils.FORMAT_DATETIME_AM_PM);
            });
        }
        this.telemedicineDataSource.data = telemedicineResponse;
        const deliveryResponse = await this.getServiceRequests('deliveryRequest', this.$route.params.id);
        if (deliveryResponse) {
            deliveryResponse.forEach((element: any) => {
                    element.appointment.date =
                    DateUtils.formatDate(element.appointment.timestamp, DateUtils.FORMAT_DATETIME_AM_PM,
                    element.appointment.timezone);
                    element.createdOn = DateUtils.formatDate(element.createdOn, DateUtils.FORMAT_DATETIME_AM_PM);
            });
            this.deliveryTableDataSource.data = deliveryResponse;
        }
    }

     private async getPatientLienRequestDocuments() {
        const iHttpService = ObjectFactory.getHttpService();
        const patientId = this.$route.params.id;
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_PATIENTS}/${patientId}/Lien`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.get<Document[]>(apiRequest);
        if (response.data && response.data.length) {
            // tslint:disable-next-line: prefer-for-of
            for (let index = 0; index < response.data.length; index++) {
                const document = response.data[index];
                document.status = document.rejected ? 'Rejected' : document.verified ? 'Verified' : 'Not Verified';
                document.verifiedOn = document.verifiedOn ? DateUtils.formatDate(document.verifiedOn) : '-' as any;
                let user: any;
                if (document.verifiedBy) {
                    user = await ObjectFactory.getUserService().getUserById(document.verifiedBy,
                        this.$store.state.serverUrl);
                }
                document.verifiedBy = document.verifiedBy ? user.data.fullname : '-';
            }
            this.lienDocumentDataSource.data = response.data;
        }
    }

    private async showUploadLienDocument() {
        this.showUploadDocumentModal = true;
    }

    private viewLienDocument(document: Document) {
        this.selectedDocument = document;
    }

    private close() {
        this.$router.back();
    }

}
